import { Controller } from "@hotwired/stimulus"

// Front / back assignment for one garment piece's frames.
//
// A SingleGenerationGarmentPiece holds exactly one front picture and one back
// picture, so of the frames a piece contributes, two get chosen. The server
// picks the first two as a starting point; this lets the operator correct it,
// which matters because a wrong back reference is invisible until the render
// comes out wrong.
//
// Clicking a frame cycles it: unassigned → FRONT → BACK → unassigned. Front and
// back are single-occupancy, so promoting a frame demotes whoever held the slot.
// The choice rides in two hidden inputs; with no JS the server's defaults still
// submit, so this only ever adds control.
export default class extends Controller {
  static targets = ["frame", "front", "back"]

  connect() {
    this.render()
  }

  cycle(event) {
    event.preventDefault()
    const id    = event.currentTarget.dataset.fileId
    const front = this.frontTarget.value
    const back  = this.backTarget.value

    if (front === id) {
      // FRONT → BACK. Whoever held back is displaced to unassigned.
      this.frontTarget.value = ""
      this.backTarget.value  = id
    } else if (back === id) {
      this.backTarget.value = ""
    } else {
      this.frontTarget.value = id
    }
    this.render()
  }

  render() {
    const front = this.frontTarget.value
    const back  = this.backTarget.value

    this.frameTargets.forEach((frame) => {
      const id     = frame.dataset.fileId
      const isFront = id === front
      const isBack  = id === back
      frame.classList.toggle("is-front", isFront)
      frame.classList.toggle("is-back", isBack)

      const badge = frame.querySelector("b")
      if (!badge) return
      badge.textContent = isFront ? "F" : isBack ? "B" : ""
      badge.classList.toggle("is-on", isFront || isBack)
    })
  }
}
